import React from 'react';
import PropTypes from 'prop-types';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableSortLabel from '@mui/material/TableSortLabel';
import TableRow from '@mui/material/TableRow';
import Checkbox from '@mui/material/Checkbox';

const headCells = [
    { id: 'id', numeric: true, disablePadding: true, label: 'Dossier' },
    { id: 'surPaletteRetour', numeric: false, disablePadding: false, label: 'Sur palette retour' },
    { id: 'dateCreation', numeric: false, disablePadding: false, label: 'Date' },
    { id: 'client', numeric: false, disablePadding: false, label: 'Client' },
    { id: 'emetteur', numeric: false, disablePadding: false, label: 'Émetteur' },
    { id: 'depotDepart', numeric: false, disablePadding: false, label: 'Dépot départ' },
    { id: 'numeroPreparation', numeric: false, disablePadding: false, label: 'Préparation' },
    { id: 'numeroPiece', numeric: false, disablePadding: false, label: 'Pièce' },
    { id: 'type', numeric: false, disablePadding: false, label: 'Type' },
    { id: 'categorie', numeric: false, disablePadding: false, label: 'Catégorie' },
    { id: 'qualification', numeric: false, disablePadding: false, label: 'Qualification' },
]

export default function ReclamationsRetourPlateformeTableHead(props) {
    const { classes, onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort } = props;
    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };

    return (
        <TableHead>
            <TableRow>
                <TableCell padding="checkbox">
                    <Checkbox
                        indeterminate={numSelected > 0 && numSelected < rowCount}
                        checked={rowCount > 0 && numSelected === rowCount}
                        onChange={onSelectAllClick}
                        inputProps={{ 'aria-label': 'select all desserts' }}
                    />
                </TableCell>
                {headCells.map((headCell) => (
                    <TableCell
                        key={headCell.id}
                        align={headCell.numeric ? 'right' : 'left'}
                        padding={headCell.disablePadding ? 'none' : 'normal'}
                        sortDirection={orderBy === headCell.id ? order : false}
                        sx={{ whiteSpace: 'nowrap' }}
                    >
                        <TableSortLabel
                            active={orderBy === headCell.id}
                            direction={orderBy === headCell.id ? order : 'asc'}
                            onClick={createSortHandler(headCell.id)}
                        >
                            {headCell.label}
                            {orderBy === headCell.id ? (
                                <span className={classes.visuallyHidden}>
                                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                </span>
                            ) : null}
                        </TableSortLabel>
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
}

ReclamationsRetourPlateformeTableHead.propTypes = {
    classes: PropTypes.object.isRequired,
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
};